import { Link, NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingBag, Image, Tag, Settings, LogOut, Terminal } from "lucide-react";
import { isAuthed, clearToken } from "../lib/auth";

const navLinks = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard, testId: "admin-nav-dashboard" },
  { to: "/admin/products", label: "Products", icon: Package, testId: "admin-nav-products" },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag, testId: "admin-nav-orders" },
  { to: "/admin/media", label: "Media", icon: Image, testId: "admin-nav-media" },
  { to: "/admin/promotions", label: "Promotions", icon: Tag, testId: "admin-nav-promotions" },
  { to: "/admin/settings", label: "Settings", icon: Settings, testId: "admin-nav-settings" },
];

export default function AdminLayout() {
  const nav = useNavigate();
  if (!isAuthed()) return <Navigate to="/admin/login" replace />;

  const logout = () => { clearToken(); nav("/admin/login"); };

  return (
    <div data-testid="admin-layout" className="min-h-screen flex">
      <aside className="w-60 border-r border-[#1E293B] bg-[#0a0a0c] hidden md:flex flex-col">
        <Link to="/" className="px-5 h-16 flex items-center gap-2 border-b border-[#1E293B]">
          <div className="w-7 h-7 rounded border border-[#00FF66]/40 bg-[#00FF66]/10 flex items-center justify-center">
            <Terminal className="w-3.5 h-3.5 text-[#00FF66]" />
          </div>
          <span className="font-heading font-bold">admin</span>
        </Link>
        <nav className="flex-1 p-3 space-y-1">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${isActive ? "bg-[#00FF66]/10 text-[#00FF66] border border-[#00FF66]/20" : "text-[#A1A1AA] hover:bg-white/5"}`
              }
            >
              <l.icon className="w-4 h-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <button data-testid="admin-logout" onClick={logout} className="m-3 flex items-center gap-2 px-3 py-2 rounded-md text-sm text-[#A1A1AA] hover:text-[#FF3B30] hover:bg-white/5">
          <LogOut className="w-4 h-4" /> Logout
        </button>
      </aside>
      <main className="flex-1 min-w-0">
        <header className="md:hidden h-14 border-b border-[#1E293B] flex items-center justify-between px-4">
          <span className="font-heading font-bold">admin</span>
          <button onClick={logout} className="text-[#A1A1AA]"><LogOut className="w-4 h-4" /></button>
        </header>
        <div className="p-6 md:p-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
